export default __webpack_public_path__ + "static/media/info-card-img1.b1d13fef.png";